import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function SearchBar({ search, onSearch, selectedLeads = [], onTransformer, onArchiver }) {
  return (
    <div className="flex items-center gap-4 w-full">
      {/* Champ de recherche */}
      <div className="relative w-1/3">
        <MagnifyingGlassIcon className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
        <input
          type="text"
          placeholder="Rechercher un lead..."
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          className="pl-10 pr-4 py-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Boutons contextuels */}
      {selectedLeads.length > 0 && (
        <div className="flex gap-2">
          <button
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded-lg transition"
            onClick={onTransformer}
          >
            Tout Transformer
          </button>
          <button
            className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg transition"
            onClick={onArchiver}
          >
            Tout Archiver
          </button>
        </div>
      )}
    </div>
  );
}
